import {makeAutoObservable} from 'mobx';

/**
 * Keeps only search term and debounce logic for the dropdown input.
 */
class NestedCheckboxesDropdownStore {
    private _searchTerm: string = '';
    private _debounceTimer?: ReturnType<typeof setTimeout>;
    private readonly _onDebouncedChange?: (term: string) => void;

    public constructor(onDebouncedChange?: (term: string) => void) {
        makeAutoObservable(this, {}, {autoBind: true});
        this._onDebouncedChange = onDebouncedChange;
    }

    /** Returns the current search input value. */
    public getSearchTerm(): string {
        return this._searchTerm;
    }

    /** Sets search input value and debounces notification to parent by 450 ms. */
    public setSearchTerm(value: string): void {
        this._searchTerm = value ?? '';
        if (this._debounceTimer) {
            clearTimeout(this._debounceTimer);
            this._debounceTimer = undefined;
        }
        this._debounceTimer = setTimeout(() => {
            if (this._onDebouncedChange) {
                this._onDebouncedChange(this._searchTerm);
            }
            this._debounceTimer = undefined;
        }, 450);
    }
}

export default NestedCheckboxesDropdownStore;